import { useEffect, useState } from "react";
import { getCurrentShow } from "../lib/showSchedule";

export function useCurrentShow(shows) {
  const [currentShow, setCurrentShow] = useState(() => getCurrentShow(shows));

  useEffect(() => {
    const updateCurrentShow = () => setCurrentShow(getCurrentShow(shows));
    updateCurrentShow();

    const intervalId = window.setInterval(updateCurrentShow, 30_000);
    return () => window.clearInterval(intervalId);
  }, [shows]);

  return currentShow;
}

export default useCurrentShow;
